export default {
  edit: { id: 'edit' },
  title: { id: 'title' },
  dateUpdated: { id: 'date_updated' },
  saveInfo: { id: 'save_info' },
  logbookFormTranslation: { id: 'logbook_form_translation' },
  logbookFormList: { id: 'logbook_form_list' },
}
